import { extendZodWithOpenApi } from "@asteasolutions/zod-to-openapi";
import { z } from "zod";

extendZodWithOpenApi(z);

// Fractional milliseconds are allowed on purpose. Existing irrigation durations were saved from an hours slider
// (for example 1.33 hours * hourMs), so plenty of stored values are not whole milliseconds. Requiring an integer here
// makes v2 responses fail response validation for those records instead of just returning the stored value.
export const milliseconds = z.number().min(0).openapi({
    type: "number",
    description: "Milliseconds",
    example: 1000,
});
